<template>
  <v-container fluid>
    <v-row class="noimprimir mt-16"> </v-row>
    <v-row class="noimprimir">
      <v-col cols="12" v-if="seeRows">
        <div style="display: flex; flex-wrap: wrap">
          <div
            style="display: flex;"
            class="mr-3"
            v-for="(item, index) in lista"
            :key="index"
          >
            <v-select
              dense
              style="max-width:200px;"
              @input="checaTodo(index)"
              :items="lista[index]"
              item-text="texto"
              item-value="valor"
              v-model="chosen[index]"
              label="Elegir filtro"
              outlined
              class="mr-1"
            ></v-select>

            <Filtros
              @buscarFiltro="busquedaHistorialEnvios($event)"
              :cuentaPasada="cuenta"
              :referenciaPasada="referenciaIPS"
              :remitentePasada="remitenteFiltro"
              :destinatarioPasado="destinatarioFiltro"
              :tipoServicioPasado="tipoServicio"
              :detalleEnvioPasado="detalleEnvio"
              :estadoPasado="estado"
              :sucursalFiltroPasada="sucursalFiltro"
              :usuarioEnvioPasada="usuarioEnvio"
              :guia_fedexPasada="guia_fedex"
              :indice="chosen[index]"
            />

            <v-btn
              color="red"
              style="color:white;"
              class="ml-1"
              @click="
                busquedaHistorialEnvios(chosen[index]);
                borrar(index);
              "
              ><v-icon medium> mdi-delete </v-icon></v-btn
            >
          </div>
          <v-btn
            v-if="lista.length < 11"
            color="blue"
            class="mr-1"
            style="color:white;"
            @click="nuevoItem()"
            >agregar filtro</v-btn
          >
          <v-btn
            v-if="lista.length > 0"
            color="blue"
            @click="eliminarFiltros()"
            style="color:white;"
            >eliminar filtros</v-btn
          >
        </div>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Historial de envíos
            <v-spacer></v-spacer>
            <!-- <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Búsqueda"
              single-line
              hide-details
              clearable
            ></v-text-field> -->
            <v-select
              outlined
              dense
              style="margin-bottom: -37px;max-width:200px;"
              :items="[5, 10, 15, 50]"
              label="Elementos por página"
              v-model="regPag"
              @input="busquedaHistorialEnvios([99])"
            ></v-select>

            <v-btn
              style="float:right; margin-top:12px;"
              color="primary"
              dark
              class="ml-2"
              @click="nuevoItem()"
              v-if="!seeRows"
              >Agregar filtro de búsqueda</v-btn
            >

            <v-btn
              style="float:right; margin-top:12px;"
              to="/envios"
              color="primary"
              dark
              class="ml-2"
              >Nuevo envio</v-btn
            >
          </v-card-title>
          <v-alert v-if="mostrarErrorCarga" outlined type="error">
            Hubo un problema cargando la información, revise su conexión a
            internet e intente nuevamente.
          </v-alert>
          <v-data-table
            :loading="tableLoading"
            loading-text="Cargando... por favor espere."
            :page.sync="pagina"
            :items-per-page="regPag"
            item-key="REFERENCIA"
            single-expand
            show-expand
            hide-default-footer
            :headers="headersHistorialEnvios"
            :items="historialEnvios.DATOS"
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <Detalles
                  @imprimir-detalle="imprimirDetalle(item)"
                  @reimprimir-abono="reimprimirAbono($event)"
                  :itemi="item"
                />
              </td>
            </template>
            <template v-slot:item.ESTADO="{ item }">
              <v-chip :color="getColor(item.ESTADO)" dark>
                {{ item.ESTADO }}
              </v-chip>
            </template>
            <template #item.actions="{ item }">
              <v-btn
                v-if="item.ESTADO != 'Pagado' && item.ESTADO != 'Cancelado'"
                @click="
                  realizarAbonoEnvio(
                    item.REFERENCIA,
                    item.ABONOS,
                    item.REMITENTE.nombre
                  )
                "
                color="green"
                class="mr-2"
                text
                rounded
                dark
              >
                Abonar
                <v-icon small class="mr-2">
                  mdi-cash-multiple
                </v-icon>
              </v-btn>

              <v-btn
                v-if="item.ESTADO != 'Cancelado'"
                text
                rounded
                color="black"
                @click="editarEnvio(item.REFERENCIA)"
                >EDITAR GUÍAS
                <v-icon small class="mr-2">
                  mdi-tooltip-edit
                </v-icon></v-btn
              >
              <v-btn
                @click="generarDocumentosInter(item)"
                v-if="
                  item.ESTADO != 'Cancelado' &&
                    item.TIPO_SERVICIO == 'Paqueteria' &&
                    (item.DETALLE_ENVIO == 'Internacional Priority' ||
                      item.DETALLE_ENVIO == 'Internacional Economy')
                "
                text
                rounded
                color="purple"
              >
                IMP. DOCTO.
                <v-icon small class="mr-2">
                  mdi-receipt
                </v-icon>
              </v-btn>
              <v-btn
                @click="reimprimirTicket(item)"
                v-if="item.ESTADO != 'Cancelado'"
                text
                rounded
                color="orange"
              >
                REIMP. TICKET
                <v-icon small class="mr-2">
                  mdi-receipt
                </v-icon>
              </v-btn>
              <v-btn
                v-if="item.ESTADO != 'Cancelado'"
                @click="
                  mostrarModalCambioDireccion = true;
                  idEnvioObtenida = item.REFERENCIA;
                  direccionObtenida = item.DIRECCION;
                  nombreDeClienteObtenido = item.REMITENTE.nombre;
                "
                text
                rounded
                color="blue"
                dark
                >C. DIR<v-icon small class="mr-2">
                  mdi-home
                </v-icon></v-btn
              >
              <v-btn
                v-if="item.ESTADO != 'Cancelado'"
                @click="eliminarEnvio(item.REFERENCIA)"
                text
                rounded
                color="red"
                dark
                >CANCELAR
                <v-icon small class="mr-2">
                  mdi-cancel
                </v-icon></v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="0" lg="4"></v-col>
      <v-col cols="12" lg="4">
        <v-pagination
          @input="busquedaHistorialEnvios([0])"
          v-model="pagina"
          :length="numeroPaginas"
        ></v-pagination>
      </v-col>
      <v-col cols="0" lg="4"> </v-col>
      <v-snackbar
        v-model="snackbarHistorialEnvios"
        timeout="2000"
        rounded="pill"
        centered
        elevation="8"
        :color="colorSnackbar"
        ><span style="font-size:20px;">
          {{ msgsnackbarHistorialEnvios }}
          <v-icon medium> mdi-check-bold </v-icon>
        </span></v-snackbar
      >
    </v-row>
    <AbonoEnvio
      @muestraMensaje="muestraAlertaEvento($event)"
      :idAbono="idAbonoModal"
      @cerrar-modal-abono-envio="modalAbonos = false"
      :mostrarAbonoEnvio="modalAbonos"
      :saldoEnvio="deudaUnSoloAbono"
      v-if="modalAbonos"
    />
    <ModalCambioDireccion
      :nombreDecliente="nombreDeClienteObtenido"
      v-if="mostrarModalCambioDireccion"
      @cerrar-modal-cdir="delayCambioDireccion($event)"
      :show="mostrarModalCambioDireccion"
      :idEnvio="idEnvioObtenida"
      :direccionPasada="direccionObtenida"
    />
    <ModalErrorEnAccion
      :mensajeError="mensajeErrorModalErrorEnAccion"
      :show="dialogErrorEnAccion"
      @cerrarModalEnAccion="dialogErrorEnAccion = false"
    />
    <ModalPrevioGenerarDocumentos
      @aceptarModalDocumentacion="modalDocumentacionAceptar()"
      @cerrarModalDocumentacion="mostrarModalGeneracionDocumentos = false"
      v-if="mostrarModalGeneracionDocumentos"
      :show="mostrarModalGeneracionDocumentos"
    />
    <ModalEdicionEnvios
      @mostrarMensajeError="
        asignaMensajeError($event);
        dialogErrorEnAccion = true;
      "
      @mostrar-mensaje-edicion-envios="
        snackbarHistorialEnvios = true;
        msgsnackbarHistorialEnvios = 'Envío editado con éxito';
        colorSnackbar = 'blue';
        busquedaHistorialEnvios([99]);
      "
      @cerrar-modal-edicion-envios="mostrarModalEdicionEnvios = false"
      v-if="mostrarModalEdicionEnvios"
      :idEnvioEditar="idEnviadaEnvioEditar"
      :show="mostrarModalEdicionEnvios"
    />
    <v-dialog
      class="noimprimir"
      v-model="dialogConfirmarEliminacion"
      persistent
      max-width="760"
      v-if="dialogConfirmarEliminacion"
    >
      <v-card>
        <v-card-title class="headline">Confirmar cancelación</v-card-title>
        <v-card-text>
          <span style="font-size:25px;">
            ¿Está seguro que desea cancelar este envío? <br />
            Esta opción no se puede deshacer.</span
          >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="dialogConfirmarEliminacion = false"
            text
            >Cancelar</v-btn
          >
          <v-btn color="red darken-1" @click="confirmarEliminacionEnvios()" text
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <ModalConfirmarEliminacion
      :show="dialogConfirmarEliminacion"
      v-if="dialogConfirmarEliminacion"
      @cerrarModalFraccion="dialogConfirmarEliminacion = false"
      @confirmarEliminacionFraccionA="confirmarEliminacionEnvios()"
    /> -->

    <img
      class="noimprimir"
      src="../assets/qr_code.png"
      style="height:1px;width:1px;"
      alt="contrato de privacidad"
    />
    <div v-if="envioAImprimir" class="imprimir imprimir-detalle">
      <Detalles :itemi="envioAImprimir" />
    </div>
    <v-row v-else class="imprimir">
      <TicketDeCompra v-if="documentoAGenerar == 1" />
      <CommercialInvoice v-if="documentoAGenerar == 2" />
      <div style="height:10px"></div>
      <TMEC v-if="documentoAGenerar == 2 && hayTMEC" />
      <!-- <PackingList /> -->
    </v-row>
  </v-container>
</template>

<script>
import TicketDeCompra from "@/components/TicketDeCompra.vue";
import CommercialInvoice from "@/components/documentos-generados/CommercialInvoice.vue";
import TMEC from "@/components/documentos-generados/TMEC.vue";
import PackingList from "@/components/documentos-generados/PackingList.vue";
import ModalPrevioGenerarDocumentos from "@/components/modales/ModalPrevioGenerarDocumentos.vue";
import ModalConfirmarEliminacion from "@/components/modales/ModalConfirmarEliminacion.vue";
import Detalles from "@/components/DetallesHistorialEnvios.vue";
import AbonoEnvio from "@/components/AbonoEnvio.vue";
import ModalCambioDireccion from "@/components/modales/ModalCambioDireccionSA.vue";
import ModalEdicionEnvios from "@/components/modales/ModalEdicionEnvios.vue";
import ModalErrorEnAccion from "@/components/modales/ModalErrorEnAccion.vue";
import Filtros from "@/components/Filtros.vue";
import _ from "lodash";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  data: () => ({
    envioAImprimir: null,
    hayTMEC: true,
    mostrarModalGeneracionDocumentos: false,
    documentoAGenerar: 1,
    dialogErrorEnAccion: false,
    mensajeErrorModalErrorEnAccion: "",
    idEnviadaEnvioEditar: "",
    mostrarModalEdicionEnvios: false,
    nombreDeClienteObtenido: "",
    idItemAborrar: 0,
    dialogConfirmarEliminacion: false,
    direccionObtenida: "",
    idEnvioObtenida: "",
    mostrarModalCambioDireccion: false,
    mostrarErrorCarga: false,
    tableLoading: false,
    deudaUnSoloAbono: 0,
    colorSnackbar: "red darken-1",
    modalAbonos: false,
    idAbonoModal: "",
    fechaInicial: "",
    fechaFinal: "",
    estado: "",
    sucursalFiltro: "",
    usuarioEnvio: "",
    cuenta: "",
    guia_fedex: "",
    detalleEnvio: "",
    tipoServicio: "",
    referenciaIPS: "",
    remitenteFiltro: "",
    destinatarioFiltro: "",
    seeRows: false,
    snackbarHistorialEnvios: false,
    msgsnackbarHistorialEnvios: "",
    lista: [],
    chosen: [],
    regPag: 10,
    pagina: 1,
    copiaHistorialEnvios: [],
    search: "",
    headersHistorialEnvios: [
      {
        text: "Referencia",
        align: "center",
        sortable: true,
        value: "REFERENCIA"
      },
      {
        text: "Fecha",
        align: "center",
        sortable: true,
        value: "FECHA"
      },
      {
        text: "Tipo de servicio",
        align: "center",
        sortable: true,
        value: "TIPO_SERVICIO"
      },
      {
        text: "Detalle envío",
        align: "center",
        sortable: true,
        value: "DETALLE_ENVIO"
      },
      {
        text: "Cliente",
        align: "center",
        sortable: true,
        value: "REMITENTE.nombre"
      },
      {
        text: "Remitente",
        align: "center",
        sortable: true,
        value: "TITULAR"
      },
      // {
      //   text: "Alias remitente",
      //   align: "center",
      //   sortable: true,
      //   value: "REMITENTE.alias"
      // },
      {
        text: "Destinatario",
        align: "center",
        sortable: true,
        value: "DESTINATARIO.nombre"
      },
      // {
      //   text: "Alias destinatario",
      //   align: "center",
      //   sortable: true,
      //   value: "DESTINATARIO.alias"
      // },
      {
        text: "Estado",
        align: "center",
        sortable: true,
        value: "ESTADO"
      },
      {
        text: "",
        align: "center",
        sortable: true,
        value: "actions"
      },
      { text: "", value: "data-table-expand" }
    ]
  }),
  components: {
    TicketDeCompra,
    Filtros,
    AbonoEnvio,
    Detalles,
    ModalCambioDireccion,
    ModalConfirmarEliminacion,
    ModalEdicionEnvios,
    ModalErrorEnAccion,
    CommercialInvoice,
    TMEC,
    PackingList,
    ModalPrevioGenerarDocumentos
  },
  async beforeDestroy() {
    await this.destroyHistorialEnvios();
  },
  methods: {
    ...mapActions("enviosInsercion", [
      "getEnvios",
      "destroyHistorialEnvios",
      "deleteEnvios"
    ]),
    ...mapActions("documentosInternacional", [
      "chargeInfoDocumento",
      "destroyInfoDocumentos"
    ]),
    ...mapActions("abonosEnvios", [
      "registraNombreAbonante",
      "destroyStoreAbonosEnvios",
      "reimprimirTicketAbono"
    ]),
    ...mapActions("ofuscadorFirma", [
      "convertirVariableTrue",
      "convertirVariableFalse"
    ]),
    ...mapActions("sucursales", ["getSucursales", "destroySucursalesStore"]),
    ...mapActions("enviosInfoEnvio", [
      "chargeinfoEnvio",
      "chargeInfoEnvioGeneradaDespues",
      "destroyStoreInfoEnvio",
      "chargeGuiasAgregadasDespues"
    ]),
    async reimprimirAbono(infoAbonoReimprimir) {
      this.documentoAGenerar = 1;
      await this.destroyInfoDocumentos();
      await this.destroyStoreInfoEnvio();
      await this.destroyStoreAbonosEnvios();

      await this.registraNombreAbonante(infoAbonoReimprimir.abonante);
      await this.reimprimirTicketAbono({
        IdEnvio: infoAbonoReimprimir.referencia,
        Fecha: infoAbonoReimprimir.fechaAbono,
        ObjTotales: {
          CostoEnvio: infoAbonoReimprimir.costoTotalEnvio,
          Abono: infoAbonoReimprimir.cantidadAbonada,
          SumAbonos: infoAbonoReimprimir.totalAbonado,
          DeudaEnvio: infoAbonoReimprimir.deudaActualEnvio,
          Cambio: "0"
        }
      });
      window.print();

      console.log(infoAbonoReimprimir);
    },
    async imprimirDetalle(envio) {
      this.envioAImprimir = envio;
      await this.$nextTick();
      window.print();
      this.envioAImprimir = null;
    },
    async modalDocumentacionAceptar() {
      this.mostrarModalGeneracionDocumentos = false;
      await this.imprimirXD();
    },
    mostrarBotonEditarGuias(item) {
      let Fecha = new Date();
      let DiaMes =
        Fecha.getDate() < 10 ? `0${Fecha.getDate()}` : Fecha.getDate();
      let Mes = Fecha.getMonth() + 1;
      let MesA = parseInt(Mes) < 10 ? `0${Mes}` : Mes;
      let Anio = Fecha.getFullYear();

      let FechaSistema = `${DiaMes}/${MesA}/${Anio}`;

      if (FechaSistema == item.FECHA.substring(0, 10)) {
        return true;
      } else {
        return false;
      }
    },
    imprimirXD: _.debounce(async function() {
      window.print();
    }, 400),
    getColor(item) {
      if (item == "Cancelado") return "red";
      else if (item == "Pagado") return "green";
      else return "yellow accent-4";
    },
    asignaMensajeError(res) {
      this.mensajeErrorModalErrorEnAccion = JSON.stringify(res);
    },
    editarEnvio(item) {
      this.idEnviadaEnvioEditar = item;
      this.mostrarModalEdicionEnvios = true;
    },

    async generarDocumentosInter(dataEnviada) {
      await this.destroyInfoDocumentos();
      await this.destroyInfoDocumentos();
      await this.destroyStoreInfoEnvio();
      await this.destroyStoreAbonosEnvios();
      await this.destroyStoreInfoEnvio();
      await this.destroyStoreAbonosEnvios();

      //todo este bloque de codigo, es para:
      // 1 agrupar todas las fracciones en un unico arreglo
      // 2 agrupar fracciones sin sinRepetir
      // 3 sacar costo total del envio multiplicando cada fraccion por su valor unitario y sumando
      let todasFracciones = [];
      for (let i = 0; i < dataEnviada.PAQUETES.InfoPaquetes.length; i++) {
        for (
          let j = 0;
          j < dataEnviada.PAQUETES.InfoPaquetes[i].fa.length;
          j++
        ) {
          todasFracciones.push(dataEnviada.PAQUETES.InfoPaquetes[i].fa[j]);
        }
      }
      const sinRepetir = JSON.parse(JSON.stringify(todasFracciones)).reduce(
        (a, b) => {
          if (a[b.id]) {
            a[b.id].cantidad =
              parseFloat(a[b.id].cantidad) + parseFloat(b.cantidad);
          } else a[b.id] = b;
          return a;
        },
        {}
      );
      const todasFraccionesSinRepetir = Object.values(sinRepetir);
      let costoTotal = todasFraccionesSinRepetir.reduce(
        (a, b) => a + b.cantidad * b.valor_unitario,
        0
      );
      //termina bloque de codigo de calculo de total
      this.mostrarModalGeneracionDocumentos = true;
      // el tmec solo se usa para envios mayores a 115 dolares
      if (
        ["México", "Estados Unidos", "Canadá"].includes(
          dataEnviada.DIRECCION[0].pais
        ) &&
        costoTotal > 115
      ) {
        this.hayTMEC = true;
      } else {
        this.hayTMEC = false;
      }
      this.documentoAGenerar = 2;
      console.log(dataEnviada, "datos enviados");
      await this.chargeInfoDocumento({
        tipoDocumento: "CommercialInvoice",
        informacion: dataEnviada
      });
      // window.print();
    },

    async reimprimirTicket(datosEnvioElegido) {
      const datosEnvio = {};
      this.documentoAGenerar = 1;
      await this.destroyInfoDocumentos();
      await this.destroyStoreInfoEnvio();
      await this.destroyStoreAbonosEnvios();
      await this.destroyStoreInfoEnvio();
      await this.destroyStoreAbonosEnvios();
      console.warn("datos envios para reimprimir ticket", datosEnvioElegido);
      if (
        datosEnvioElegido.DETALLE_ENVIO == "Nacional Dia siguiente" ||
        datosEnvioElegido.DETALLE_ENVIO == "Nacional Terrestre"
      ) {
        if (
          datosEnvioElegido.DETALLE_ENVIO == "Nacional Dia siguiente" &&
          datosEnvioElegido.TIPO_SERVICIO == "Paqueteria"
        ) {
          datosEnvio.tipoEnvio = "Paqueteria nacional día siguiente";
        } else if (
          datosEnvioElegido.DETALLE_ENVIO == "Nacional Terrestre" &&
          datosEnvioElegido.TIPO_SERVICIO == "Paqueteria"
        ) {
          datosEnvio.tipoEnvio = "Paqueteria nacional terrestre";
        } else if (
          datosEnvioElegido.DETALLE_ENVIO == "Nacional Terrestre" &&
          datosEnvioElegido.TIPO_SERVICIO == "Mensajeria"
        ) {
          datosEnvio.tipoEnvio = "Mensajeria nacional terrestre";
        } else {
          datosEnvio.tipoEnvio = "Mensajeria nacional día siguiente";
        }

        datosEnvio.DescripcionEnvioNacional =
          datosEnvioElegido.PAQUETES.Descripcion;

        // esta excepcion es para los envios internacionales, generamos el objeto para ese caso
      } else if (
        datosEnvioElegido.DETALLE_ENVIO == "Internacional Priority" ||
        datosEnvioElegido.DETALLE_ENVIO == "Internacional Economy"
      ) {
        // primero cargamos la informacion del tipo de envio que se hará
        if (
          datosEnvioElegido.DETALLE_ENVIO == "Internacional Priority" &&
          datosEnvioElegido.TIPO_SERVICIO == "Paqueteria"
        ) {
          datosEnvio.tipoEnvio = "Paqueteria internacional priority";
        } else if (
          datosEnvioElegido.DETALLE_ENVIO == "Internacional Economy" &&
          datosEnvioElegido.TIPO_SERVICIO == "Paqueteria"
        ) {
          datosEnvio.tipoEnvio = "Paqueteria Internacional economy";
        } else if (
          datosEnvioElegido.DETALLE_ENVIO == "Internacional Priority" &&
          datosEnvioElegido.TIPO_SERVICIO == "Mensajeria"
        ) {
          datosEnvio.tipoEnvio = "Mensajeria internacional priority";
        } else {
          datosEnvio.tipoEnvio = "Mensajeria internacional economy";
        }

        // cargamos la informacion de descripcion de inter y de destinatario
        datosEnvio.DescripcionEnvioInter =
          datosEnvioElegido.PAQUETES.Descripcion;

        // TODO lo de abajo aplica para ambos tipos de envio, lo de arriba no
      }

      datosEnvio.InfoDestinatario = {};
      datosEnvio.InfoDestinatario.alias = datosEnvioElegido.DESTINATARIO.alias;
      datosEnvio.InfoDestinatario.nombre =
        datosEnvioElegido.DESTINATARIO.nombre;
      datosEnvio.InfoDestinatario.telefono =
        datosEnvioElegido.DESTINATARIO.telefono;

      datosEnvio.InfoDestinatario.ciudad =
        datosEnvioElegido.DIRECCION[0].municipio;
      datosEnvio.InfoDestinatario.colonia =
        datosEnvioElegido.DIRECCION[0].colonia;
      datosEnvio.InfoDestinatario.cp =
        datosEnvioElegido.DIRECCION[0].codigopostal;
      datosEnvio.InfoDestinatario.direccion =
        datosEnvioElegido.DIRECCION[0].direccion;
      datosEnvio.InfoDestinatario.estado =
        datosEnvioElegido.DIRECCION[0].estado;
      datosEnvio.InfoDestinatario.pais = datosEnvioElegido.DIRECCION[0].pais;
      datosEnvio.InfoDestinatario.email = "";
      // remitente
      datosEnvio.InfoRemitente = {};
      datosEnvio.InfoRemitente.nombre = datosEnvioElegido.REMITENTE.nombre;

      datosEnvio.InfoRemitente.ciudad =
        datosEnvioElegido.DIRECCION_REMITENTE[0].municipio;
      datosEnvio.InfoRemitente.colonia =
        datosEnvioElegido.DIRECCION_REMITENTE[0].colonia;
      datosEnvio.InfoRemitente.cp =
        datosEnvioElegido.DIRECCION_REMITENTE[0].codigopostal;
      datosEnvio.InfoRemitente.direccion =
        datosEnvioElegido.DIRECCION_REMITENTE[0].direccion;
      datosEnvio.InfoRemitente.estado =
        datosEnvioElegido.DIRECCION_REMITENTE[0].estado;
      datosEnvio.InfoRemitente.pais =
        datosEnvioElegido.DIRECCION_REMITENTE[0].pais;

      datosEnvio.Titular = datosEnvioElegido.TITULAR + "";

      //total
      datosEnvio.InfoPagos = new Object();
      datosEnvio.InfoPagos.Total = datosEnvioElegido.ABONOS.total;
      // pagado
      datosEnvio.InfoPagos.cantidad =
        datosEnvioElegido.ABONOS.total -
        (await this.calculaDeudaActual(datosEnvioElegido.ABONOS));

      // usuario del envio
      datosEnvio.InfoUsuario = new Object();
      datosEnvio.InfoUsuario.nombre = this.logedInUserInfo.nombre;

      if (datosEnvioElegido.TIPO_SERVICIO == "Mensajeria") {
        datosEnvio.InfoMensajeria = new Object();
        //arreglar aqui
        datosEnvio.DescripcionMensajeriaFinal =
          datosEnvioElegido.PAQUETES.Descripcion;
        datosEnvio.InfoMensajeria =
          datosEnvioElegido.PAQUETES.InfoMensajeria[0];
        datosEnvio.InfoMensajeria.guiaRastreo =
          datosEnvioElegido.PAQUETES.InfoMensajeria[0].guia;
      } else {
        datosEnvio.InfoPaqueteriaN = new Object();
        datosEnvio.InfoPaqueteriaN = datosEnvioElegido.PAQUETES.InfoPaquetes;
      }
      //servicios adicionales

      if (datosEnvioElegido.SERVICIO_ADICIONAL != null) {
        datosEnvio.ServiciosAdicionales = new Object();
        if (datosEnvioElegido.SERVICIO_ADICIONAL.empaque) {
          datosEnvio.ServiciosAdicionales.empaque =
            datosEnvioElegido.SERVICIO_ADICIONAL.empaque;
        }
        if (datosEnvioElegido.SERVICIO_ADICIONAL.rempaque) {
          datosEnvio.ServiciosAdicionales.rempaque =
            datosEnvioElegido.SERVICIO_ADICIONAL.rempaque;
        }
        if (datosEnvioElegido.SERVICIO_ADICIONAL.entrega_sabado) {
          datosEnvio.ServiciosAdicionales.entrega_sabado =
            datosEnvioElegido.SERVICIO_ADICIONAL.entrega_sabado;
        }
        if (datosEnvioElegido.SERVICIO_ADICIONAL.recoleccion) {
          datosEnvio.ServiciosAdicionales.recoleccion =
            datosEnvioElegido.SERVICIO_ADICIONAL.recoleccion;
        }
        if (datosEnvioElegido.SERVICIO_ADICIONAL.seguro) {
          datosEnvio.ServiciosAdicionales.seguro =
            datosEnvioElegido.SERVICIO_ADICIONAL.seguro;
          datosEnvio.ServiciosAdicionales.valorcontenido =
            datosEnvioElegido.SERVICIO_ADICIONAL.valorcontenido;
        }
        if (datosEnvioElegido.SERVICIO_ADICIONAL.servicio_guia) {
          datosEnvio.ServiciosAdicionales.servicio_guia =
            datosEnvioElegido.SERVICIO_ADICIONAL.servicio_guia;
        }
        if (datosEnvioElegido.SERVICIO_ADICIONAL.zona_expedida) {
          datosEnvio.ServiciosAdicionales.zona_expedida =
            datosEnvioElegido.SERVICIO_ADICIONAL.zona_expedida;
        }
      }

      //aqui mandamos los datos que se envian despues para el ticket y
      //cargamos los datos del objeto de envio que acabamos de crear
      var datosEnvioDespues = new Object();
      datosEnvioDespues.envio = {
        Fecha: datosEnvioElegido.FECHA,
        ID: datosEnvioElegido.REFERENCIA
      };

      await this.chargeinfoEnvio(datosEnvio);
      await this.chargeInfoEnvioGeneradaDespues(datosEnvioDespues);
      let arrayGuias = [];
      if (datosEnvioElegido.TIPO_SERVICIO == "Paqueteria") {
        for (
          let i = 0;
          i < datosEnvioElegido.PAQUETES.InfoPaquetes.length;
          i++
        ) {
          arrayGuias.push(datosEnvioElegido.PAQUETES.InfoPaquetes[i].guia);
        }
      }
      await this.chargeGuiasAgregadasDespues(arrayGuias);

      //esto de abajo se hace para ambos no importa si son inter o nacionales

      await this.convertirVariableTrue();
      window.print();
      await this.convertirVariableFalse();
      window.print();
    },
    calculaDeudaActual(abonos) {
      let pagosHechos = 0;
      for (var i = 0; i < abonos.Abonos.length; i++) {
        pagosHechos += parseFloat(abonos.Abonos[i].cantidad);
      }
      const deudaActual = parseFloat(abonos.total) - parseFloat(pagosHechos);
      return deudaActual;
    },
    eliminarEnvio(data) {
      this.idItemAborrar = data;
      this.dialogConfirmarEliminacion = true;
    },
    async confirmarEliminacionEnvios() {
      const res = await this.deleteEnvios(this.idItemAborrar);
      this.dialogConfirmarEliminacion = false;
      if (res[0]) {
        this.snackbarHistorialEnvios = true;
        this.msgsnackbarHistorialEnvios = "Envío cancelado con éxito";
        this.colorSnackbar = "blue";
        this.busquedaHistorialEnvios(777);
      }
    },
    async delay2() {
      this.mostrarModalCambioDireccion = false;
      this.busquedaHistorialEnvios(777);
    },
    async delayCambioDireccion(evento) {
      await this.delay2();
      if (evento != "cancela") {
        window.print();
        window.print();
      }
    },
    async eliminarFiltros() {
      this.lista = [];
      this.chosen = [];
      this.seeRows = false;
      // caso 666 reinicia las variables y hace la busqueda
      this.busquedaHistorialEnvios(666);
    },
    busquedaHistorialEnvios: _.debounce(async function(arregloDatosFiltros) {
      this.tableLoading = true;
      // si existe el objeto es porque se ingresaron filtros, caso contrario
      // se debe hacer la busqueda sin nada
      if (arregloDatosFiltros) {
        if (Array.isArray(arregloDatosFiltros)) {
          switch (arregloDatosFiltros[0]) {
            //referencia ips
            case 1:
              //console.log("agregar filtro referencia");
              this.pagina = 1;
              this.referenciaIPS = arregloDatosFiltros[1];
              break;
            case 2:
              // console.log("agregar filtro remitente");
              this.pagina = 1;
              this.remitenteFiltro = arregloDatosFiltros[1];
              break;
            case 3:
              //console.log("agregar filtro destinatario");
              this.pagina = 1;
              this.destinatarioFiltro = arregloDatosFiltros[1];
              break;
            case 4:
              //console.log("agregar filtro tipo servicio");
              this.pagina = 1;
              this.tipoServicio = arregloDatosFiltros[1];
              break;
            case 5:
              //console.log("agregar filtro detalle envio");
              this.pagina = 1;
              this.detalleEnvio = arregloDatosFiltros[1];
              break;
            case 6:
              //console.log("agregar filtro estado");
              this.pagina = 1;
              this.estado = arregloDatosFiltros[1];
              break;
            case 7:
              this.pagina = 1;
              this.sucursalFiltro = arregloDatosFiltros[1];
              break;
            case 8:
              this.pagina = 1;
              this.usuarioEnvio = arregloDatosFiltros[1];
              break;
            case 9:
              this.pagina = 1;
              this.cuenta = arregloDatosFiltros[1];
              break;
            case 10:
              this.pagina = 1;
              this.guia_fedex = arregloDatosFiltros[1];
              break;
            case 11:
              try {
                this.pagina = 1;
                this.fechaInicial = arregloDatosFiltros[1];
                this.fechaFinal = arregloDatosFiltros[2];
              } catch {}
              break;
            //
            case 99:
              this.pagina = 1;
              break;
            default:
              break;
          }
        } else {
          switch (arregloDatosFiltros) {
            //referencia ips

            case 1:
              //console.log("quitar filtro referencia");
              this.referenciaIPS = "";
              break;
            case 2:
              //console.log("quitar filtro remitente");
              this.remitenteFiltro = "";
              break;
            case 3:
              //console.log("quitar filtro destinatario");
              this.destinatarioFiltro = "";
              break;
            case 4:
              //console.log("quitar filtro tipo servicio");
              this.tipoServicio = "";
              break;
            case 5:
              this.detalleEnvio = "";
              break;
            case 6:
              //console.log("quitar filtro estado");
              this.estado = "";
              break;
            case 7:
              this.sucursalFiltro = "";
              break;
            case 8:
              this.usuarioEnvio = "";
              break;
            case 9:
              this.cuenta = "";
              break;
            case 10:
              this.guia_fedex = "";
              break;
            case 11:
              this.fechaFinal = "";
              this.fechaInicial = "";
              break;
            case 666:
              this.referenciaIPS = "";
              this.remitenteFiltro = "";
              this.destinatarioFiltro = "";
              this.tipoServicio = "";
              this.detalleEnvio = "";
              this.estado = "";
              this.sucursalFiltro = "";
              this.usuarioEnvio = "";
              this.cuenta = "";
              this.guia_fedex = "";
              this.fechaFinal = "";
              this.fechaInicial = "";
              break;
            default:
              break;
          }
        }
        // objetoBusqueda.pag = this.pagina;
        // objetoBusqueda.regPag = this.regPag;
        const res = await this.getEnvios({
          pag: this.pagina,
          regPag: this.regPag,
          referencia: this.referenciaEdit,
          remitente: this.remitenteEdit,
          destinatario: this.destinatarioEdit,
          fecha_inicio: this.fechaInicial,
          fecha_fin: this.fechaFinal,
          tipoServicio: this.tipoServicioEdit,
          detalleEnvio: this.detalleEnvioEdit,
          estado: this.estadoEdit,
          usuarioEnvio: this.usuarioEdit,
          cuenta: this.cuentaEdit,
          guia_fedex: this.guiaFedexEdit,
          sucursal: this.sucursalEdit
        });
        if (res[0] == false) {
          if ((res[1] = "errorcarga")) {
            this.mostrarErrorCarga = true;
          }
        } else {
          this.mostrarErrorCarga = false;
        }
      } else {
        //estos van en blanco, porque son los que se
        // muestran al cargar la pagina por primera vez
        const res = await this.getEnvios({
          pag: this.pagina,
          regPag: this.regPag,
          referencia: this.referenciaEdit,
          remitente: this.remitenteEdit,
          destinatario: this.destinatarioEdit,
          fecha_inicio: "",
          fecha_fin: "",
          tipoServicio: this.tipoServicioEdit,
          detalleEnvio: this.detalleEnvioEdit,
          estado: this.estadoEdit,
          usuarioEnvio: this.usuarioEdit,
          cuenta: this.cuentaEdit,
          guia_fedex: this.guiaFedexEdit,
          sucursal: this.sucursalEdit
        });
        if (res[0] == false) {
          if ((res[1] = "errorcarga")) {
            this.mostrarErrorCarga = true;
          }
        } else {
          this.mostrarErrorCarga = false;
        }
      }
      this.tableLoading = false;
    }, 400),
    nuevoItem() {
      for (let i = 0; i < this.chosen.length; i++) {
        if (this.chosen[i] == undefined) {
          this.msgsnackbarHistorialEnvios = "Revise sus filtros ingresados";
          this.snackbarHistorialEnvios = true;
          return;
        }
      }
      this.lista.push([
        { valor: 1, texto: "REFERENCIA IPS" },
        { valor: 2, texto: "REMITENTE" },
        { valor: 3, texto: "DESTINATARIO" },
        { valor: 4, texto: "TIPO SERVICIO" },
        { valor: 5, texto: "DETALLE ENVIO" },
        { valor: 6, texto: "ESTADO" },
        { valor: 7, texto: "SUCURSAL" },
        { valor: 8, texto: "USUARIO" },
        { valor: 9, texto: "CUENTA" },
        { valor: 11, texto: "RANGO DE FECHAS" },
        { valor: 10, texto: "GUIA FEDEX" }
      ]);
      this.chosen.push(undefined);

      this.seeRows = true;
    },
    checaTodo(index) {
      //   var x = [1, 2, 3, 4, 5, 6];
      var y = this.chosen.filter(function(item, index2, array) {
        return array.indexOf(item) === index2;
      });
      //   console.log(y);
      if (this.chosen.length === y.length) {
      } else {
        this.msgsnackbarHistorialEnvios =
          "El filtro ingresado ya se encuentra en el listado de filtros";
        this.colorSnackbar = "red darken-1";
        this.snackbarHistorialEnvios = true;
        this.chosen[index] = undefined;
      }
    },
    calculaDeudaActual(abonos) {
      let pagosHechos = 0;
      for (var i = 0; i < abonos.Abonos.length; i++) {
        pagosHechos += parseFloat(abonos.Abonos[i].cantidad);
      }
      const deudaActual = parseFloat(abonos.total) - parseFloat(pagosHechos);
      return deudaActual;
    },
    delayOcultarModalAbonos() {
      this.modalAbonos = false;
      this.snackbarHistorialEnvios = true;
      this.msgsnackbarHistorialEnvios = "Abono correctamente realizado";
      this.colorSnackbar = "blue darken-1";
    },
    async muestraAlertaEvento(evento) {
      if (evento == "abonoCorrecto") {
        await this.delayOcultarModalAbonos();
        window.print();
        window.print();
      } else if (evento == "envioprevpagado") {
        this.modalAbonos = false;
        this.snackbarHistorialEnvios = true;
        this.msgsnackbarHistorialEnvios =
          "El envio ya está completamente pagado, no es posible realizar otro abono.";
        this.colorSnackbar = "red darken-1";
      }
      this.busquedaHistorialEnvios([99]);
    },
    async borrar(index) {
      switch (this.chosen[index]) {
        case 1:
          this.referenciaIPS = "";
          break;
        case 2:
          this.remitenteFiltro = "";
          break;
        case 3:
          this.destinatarioFiltro = "";
        case 4:
          this.tipoServicio = "";
        case 5:
          this.detalleEnvio = "";
        case 6:
          this.estado = "";
        case 7:
          this.sucursalFiltro = "";
        case 8:
          this.usuarioEnvio = "";
        case 9:
          this.cuenta = "";
        case 10:
          this.guia_fedex = "";
        case 11:
          this.fechaFinal = "";
          this.fechaInicial = "";
          break;
        default:
          break;
      }
      this.seeRows = false;
      await this.chosen.splice(index, 1);
      await this.lista.splice(index, 1);

      if (this.lista.length == 0) {
        this.seeRows = false;
      } else {
        this.seeRows = true;
      }
      this.busquedaHistorialEnvios([99]);
    },
    async realizarAbonoEnvio(referencia, abonos, nombreAbonante) {
      await this.registraNombreAbonante(nombreAbonante);
      const deudaEnvioEspecifico = await this.calculaDeudaActual(abonos);
      this.deudaUnSoloAbono = deudaEnvioEspecifico;
      this.idAbonoModal = referencia;
      this.modalAbonos = true;
    }
  },
  async beforeMount() {
    await this.busquedaHistorialEnvios();
  },
  async mounted() {
    await this.getSucursales();
  },
  computed: {
    ...mapState("enviosInsercion", {
      historialEnvios: state => state.historialEnvios
    }),
    ...mapState("sucursales", {
      sucursalesList: state => state.sucursales
    }),
    ...mapState("sesion", {
      sucursalInfo: state => state.sucursalData,
      logedInUserInfo: state => state.logedInUserInfo
    }),
    //TODO
    referenciaEdit() {
      return this.referenciaIPS == "" || this.referenciaIPS == null
        ? ""
        : `&referencia=${this.referenciaIPS}`;
    },
    remitenteEdit() {
      return this.remitenteFiltro == "" || this.remitenteFiltro == null
        ? ""
        : `&remitente=${this.remitenteFiltro}`;
    },
    destinatarioEdit() {
      return this.destinatarioFiltro == "" || this.destinatarioFiltro == null
        ? ""
        : `&destinatario=${this.destinatarioFiltro}`;
    },
    tipoServicioEdit() {
      return this.tipoServicio == "" || this.tipoServicio == null
        ? ""
        : `&tipo_servicio=${this.tipoServicio}`;
    },
    //TODO
    detalleEnvioEdit() {
      return this.detalleEnvio == "" || this.detalleEnvio == null
        ? ""
        : `&detalle_envio=${this.detalleEnvio}`;
    },
    estadoEdit() {
      return this.estado == "" || this.estado == null
        ? ""
        : `&estado=${this.estado}`;
    },
    usuarioEdit() {
      return this.usuarioEnvio == "" || this.usuarioEnvio == null
        ? ""
        : `&usuario=${this.usuarioEnvio}`;
    },
    cuentaEdit() {
      return this.cuenta == "" || this.cuenta == null
        ? ""
        : `&cuenta=${this.cuenta}`;
    },
    guiaFedexEdit() {
      return this.guia_fedex == "" || this.guia_fedex == null
        ? ""
        : `&guia_fedex=${this.guia_fedex}`;
    },
    sucursalEdit() {
      return this.sucursalFiltro == "" || this.sucursalFiltro == null
        ? ""
        : `&sucursal=${this.sucursalFiltro}`;
    },
    rangoFechaInicial() {
      return this.rangoDeFechas
        ? moment(this.rangoDeFechas[0]).format("L")
        : "";
    },
    rangoFechaFinal() {
      return this.rangoDeFechas
        ? moment(this.rangoDeFechas[1]).format("L")
        : "";
    },
    numeroPaginas() {
      if (this.historialEnvios.INFO) {
        return this.historialEnvios.INFO.paginacion.Paginas;
      } else {
        return 0;
      }
    }
  }
};
</script>
<style lang="css" scoped>
.imprimir {
  display: none;
}
@media print {
  .noimprimir {
    display: none;
  }
  .imprimir {
    display: block;
  }
  .imprimir-detalle {
    margin: 0;
    padding: 0;
    width: 100%;
  }
}
</style>
